export default __webpack_public_path__ + "static/media/upload.e05e3167.svg";